import OriginalFactoryTires from 'pages/CatalogPage/DH/Tires/OriginalFactoryTires/OriginalFactoryTires';

export default OriginalFactoryTires;
